import images from "../../../constant/images";

import { useTranslation } from "react-i18next";

import Header from "../../../layouts/header";

import { WrittenPress } from "./press/written_press";
import { VisualPress } from "./press/visual_press";
import '../media/press/press.css';

export const Press = () => {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <>
      <div className="flex flex-col gap-[2rem]  mb-[5rem]">
        <Header image={images.press} title={t("media.press.title")} />
      </div>

      <WrittenPress />

      <VisualPress />
    </>
  );
};
